import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from './link-button.jsx';

/**
 * Renders a button that redirects the user to the provided path when clicked.
 * This button is styled as the secondary button in the style guide.
 *
 * Style guide: https://www.figma.com/file/Yc102rMJTZghOwuY7hUiFC/REVIEW_Luminis-Health-Web_Comps?type=design&node-id=571-10343&mode=design&t=ANofraeeTPYw9Kgg-4
 */
const SecondaryLinkButton = ({ children, href, clickHandler, className, tabIndex }) => {
  let classList = 'outline';

  if (className) {
    classList += ` ${className}`;
  }

  return (
    <LinkButton
      className={classList}
      href={href}
      clickHandler={clickHandler}
      tabIndex={tabIndex}
    >
      {children}
    </LinkButton>
  );
}

SecondaryLinkButton.propTypes = {
  /**
   * the path to redirect the user to when the button is clicked
   */
  href: PropTypes.string.isRequired,
  /**
   * the callback function for when the button is clicked
   */
  clickHandler: PropTypes.func,
  /**
   * additional classes to add to the button
   */
  className: PropTypes.string,
  /**
   * the tabindex for the button
   */
  tabIndex: PropTypes.number,
};

SecondaryLinkButton.defaultProps = {
  tabIndex: 0,
};

export default SecondaryLinkButton;
